import { LOGOUT_CLIENT_PANEL, LOGOUT_CLIENT_PANEL_SUCCESS, LOGOUT_CLIENT_PANEL_ERROR, LOGOUT_CLIENT_PANEL_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const LogoutClientPanel = (state = initialState, action) => {
  switch (action.type) {
    case LOGOUT_CLIENT_PANEL:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case LOGOUT_CLIENT_PANEL_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case LOGOUT_CLIENT_PANEL_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case LOGOUT_CLIENT_PANEL_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default LogoutClientPanel;
